<template>
  <v-container fluid pa-0 mb-5>
    <HeaderNotificacao 
      pageTitle="Notificações" 
      :loading="loadingNotificacoes"
      @atualizaListaNotificacoes="atualizaListaNotificacoes"
      @filtraStatusNotificacoes="filtraStatusNotificacoes"
      @filtraNotificacoesLidas="filtraNotificacoesLidas"
    />
    <v-layout wrap justify-center>
      <v-flex xs12 lg9>
        <v-checkbox
          v-model="atualizaAuto"
          class="mt-4 pt-3"
          :class="{ 'mx-3': $vuetify.breakpoint.xsOnly }"
          label="ATUALIZAÇÃO AUTOMÁTICA"
          color="primary"
        ></v-checkbox>
        <FiltroNotificacao 
          v-if="statusSelected == 'F'" 
          @filtraNotificacoesLidas="filtraNotificacoesLidas"
        />
      </v-flex>
      <v-flex
        v-if="notificacoes.length"
        xs12
        lg9
        justify-center
        :mt-4="statusSelected === 'F'"
      ><NotificacaoContainer 
          v-for="(notificacao, index) in computedNotificacoesGrouped" 
          :key="index" 
          :atividadeNotificacao="notificacao"
        />
      </v-flex>
      <v-flex
        v-else
        xs12
        lg9
        justify-center
      >
      <div
        class="text-xs-center white py-3 body-2 text-uppercase"
        :class="{ 'mt-3': statusSelected === 'F' }"
      >Nenhuma notificação encontrada</div>
      </v-flex>
    </v-layout>
    <v-layout v-if="totalPages" row justify-center mt-3>
      <v-flex xs12 lg9 class="text-xs-center">
        <v-pagination
          v-model="page"
          :length="totalPages"
          @input="salvaPaginacaoAtual"
          @next="scrollTopo"
          @previous="scrollTopo"
        ></v-pagination>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import HeaderNotificacao from '@/components/notificacao/HeaderNotificacao';
import NotificacaoContainer from '@/components/notificacao/NotificacaoContainer';
import FiltroNotificacao from '@/components/notificacao/FiltroNotificacao';
import AtividadeNotificacao from '@/domain/notificacao/AtividadeNotificacao';
import { changePageTitle } from '../utils/changePageTitle';

export default {
  name: 'GerenciadorNotificacoes',
  components: {
    HeaderNotificacao,
    NotificacaoContainer,
    FiltroNotificacao
  },
  data: () => ({
    page: 1,
    interval: null,
    loadingNotificacoes: false,
    statusSelected: 'P',
    filtroSelected: 'hoje',
    periodo: {
      dataInicial: new Date().toISOString().substr(0, 10),
      dataFinal: new Date().toISOString().substr(0, 10)
    },
  }),
  methods: {
    ...mapActions(['fetchNotificacoesPorStatus', 'setAtualizaNotificacoesAuto', 'loadConfigNotificacoes']),
    scrollTopo() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    salvaPaginacaoAtual(page) {
      localStorage.setItem('notificacoesPage', page);
      this.scrollTopo();
    },
    recuperaPaginacaoSalva() {
      if (localStorage.getItem('notificacoesPage')) {
        const savedPage = localStorage.getItem('notificacoesPage');
        this.page = Number(savedPage);
      }
    },
    async atualizaListaNotificacoes() {
      if (this.statusSelected === 'P') {
        this.loadingNotificacoes = true;
        await this.fetchNotificacoesPorStatus({ status: this.statusSelected, idColaborador: this.user.IdColaborador });
        this.loadingNotificacoes = false;
      } else {
        this.filtraNotificacoesLidas({ tipo: this.filtroSelected, data: this.periodo });
      }
    },
    filtraStatusNotificacoes(status) {
      this.statusSelected = status;
      this.fetchNotificacoesPorStatus({ status: this.statusSelected, idColaborador: this.user.IdColaborador });
    },
    async filtraNotificacoesLidas(payload) {
      this.statusSelected = 'F';
      this.filtroSelected = payload.tipo;
      let dtInicial;
      let dtFinal;

      switch (payload.tipo) {
        case 'hoje':
          dtInicial = this.moment.utc().startOf('day').format('YYYY-MM-DD');
          dtFinal = this.moment.utc().endOf('day').format('YYYY-MM-DD');
          await this.fetchNotificacoesPorStatus(
            { 
              status: this.statusSelected,
              idColaborador: this.user.IdColaborador,
              dtInicial,
              dtFinal
            }
          );
          break;
        case 'semana':
          dtInicial = this.moment.utc().weekday(0).format('YYYY-MM-DD');
          dtFinal = this.moment.utc().weekday(5).format('YYYY-MM-DD');
          await this.fetchNotificacoesPorStatus(
            { 
              status: this.statusSelected,
              idColaborador: this.user.IdColaborador,
              dtInicial,
              dtFinal
            }
          );
          break;
        case 'mes':
          dtInicial = this.moment.utc().startOf('month').format('YYYY-MM-DD');
          dtFinal = this.moment.utc().endOf('month').format('YYYY-MM-DD');
          await this.fetchNotificacoesPorStatus(
            { 
              status: this.statusSelected,
              idColaborador: this.user.IdColaborador,
              dtInicial,
              dtFinal
            }
          );
          break;
        case 'periodo':
          this.periodo.dataInicial = payload.data.dataInicial;
          this.periodo.dataFinal = payload.data.dataFinal;
          
          dtInicial = payload.data.dataInicial;
          dtFinal = payload.data.dataFinal;
          await this.fetchNotificacoesPorStatus(
            { 
              status: this.statusSelected,
              idColaborador: this.user.IdColaborador,
              dtInicial,
              dtFinal
            }
          );
          break;
      }
    },
    inicializaNotificacoes() {
      clearInterval(this.interval);
      this.interval = setInterval(async () => {
        await this.atualizaListaNotificacoes();
      }, 120000);
    },
    async getNotificacoes() {
      if (!this.notificacoes.length) await this.fetchNotificacoesPorStatus({ status: this.statusSelected, idColaborador: this.user.IdColaborador });
    }
  },
  computed: {
    ...mapGetters(['user', 'notificacoes', 'atualizaNotificacoesAuto']),
    totalPages() {
      const pages = Math.ceil(this.uniqueNotificacoes.length / 10);
      localStorage.setItem('notificacoesTotalPages', pages);
      return pages;
    },
    uniqueNotificacoes() {
      const IdsAtividades = Array.from(new Set(this.notificacoes.map(n => n.IdAtividade)));
      const notificacoesAtividade = [];

      if (IdsAtividades) {
        IdsAtividades.forEach(id => {
          const newAtividadeNotificacao = new AtividadeNotificacao();
          newAtividadeNotificacao.IdAtividade = id;
          newAtividadeNotificacao.Notificacoes = 
            this.notificacoes.filter(notificacao => notificacao.IdAtividade == id);
          
          newAtividadeNotificacao.Atividade = 
            newAtividadeNotificacao.Notificacoes.length ? 
            newAtividadeNotificacao.Notificacoes[0].Atividade : '';

          newAtividadeNotificacao.Clientes =
            newAtividadeNotificacao.Notificacoes.length ? 
            newAtividadeNotificacao.Notificacoes[0].Clientes : '';

          if (newAtividadeNotificacao.Notificacoes.length) {
            notificacoesAtividade.push(newAtividadeNotificacao);
          }
        });
      }
      return notificacoesAtividade.length ? notificacoesAtividade : [];
    },
    computedNotificacoesGrouped() {
      const inicio = (this.page - 1) * 10,
            fim = inicio + 10;
      return this.uniqueNotificacoes.slice(inicio, fim);
    },
    atualizaAuto: {
      get() {
        return this.atualizaNotificacoesAuto;
      },
      set(value) {
        this.setAtualizaNotificacoesAuto(value);
      }
    }
  },
  watch: {
    atualizaNotificacoesAuto(value) {
      if (value) this.inicializaNotificacoes();
      else clearInterval(this.interval);
    }
  },
  async created() {
    changePageTitle('Notificações');
    this.loadConfigNotificacoes();
    await this.getNotificacoes();
    if (this.atualizaNotificacoesAuto) this.inicializaNotificacoes();
    this.recuperaPaginacaoSalva();
  },
  destroyed() {
    clearInterval(this.interval);
  }
}
</script>

<style>

</style>
